import { gql } from '@apollo/client';
const ADD_MODEL_PICTURE = gql `
  mutation AddModelPicture($modelSpecificationId: ID!, $file: String!) {
    addModelSpecificationPicture(modelSpecificationId: $modelSpecificationId, file: $file) {
      modelSpecification {
        id
        image
      }
    }
  }
`;
export default ADD_MODEL_PICTURE;
